import { PORTAL_MENU_ROOT_ID } from '../../constants';

import { useStyles } from './PortalHeader.styles';
import { usePortalMenuHeight, usePortalResources } from './hooks';

interface PortalHeaderProps {
  onHeightChange?: (height: number) => void;
}

export const PortalHeader = ({ onHeightChange }: PortalHeaderProps) => {
  const { classes } = useStyles();
  const menuRef = usePortalMenuHeight(onHeightChange);

  usePortalResources();

  return (
    <div className={classes.root}>
      <div ref={menuRef} id={PORTAL_MENU_ROOT_ID} />
    </div>
  );
};
